<template>
  <div :class="['bg-off-white-30', props.class]">
    <div class="mb-2 pt-6 lg:pt-8.5">
      <h3 v-if="title" class="ui-text-m uppercase max-lg:pl-4" v-html="title" />
    </div>
    <UiScrollableSlider
      :slides-count="1.5"
      :items-list="products"
      class="lg:!hidden"
      :gap-x="8"
    >
      <template #card="{ item, idx }">
        <ProductListCarouselCard
          :product="item"
          :product-index="idx"
          :plp-type="plpTypes.default"
          :statistic-item-list-name="statisticItemListName"
          :statistic-item-list-id="statisticItemListId"
        />
      </template>
    </UiScrollableSlider>
    <div
      class="max-lg:hidden max-lg:max-w-full lg:max-w-[548px] lg2:max-w-[772px] xl:max-w-[932px] 2xl:max-w-[1004px] 3xl:max-w-[1476px]"
    >
      <Swiper
        :slides-per-view="2"
        :modules="modules"
        :space-between="8"
        :navigation="navigation"
        :breakpoints="{
          [screens.xl]: {
            spaceBetween: 16,
            slidesPerView: 3,
          },
        }"
        @swiper="initSwiper"
        @resize="onUpdateSwiper"
      >
        <SwiperSlide
          v-for="(item, idx) in products?.slice(0, 15)"
          :key="item.id"
          class="!h-auto max-md:px-2.5"
        >
          <ProductListCarouselCard
            :product="item"
            :product-index="idx"
            :plp-type="plpTypes.default"
            :statistic-item-list-name="statisticItemListName"
            :statistic-item-list-id="statisticItemListId"
          />
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper";
import { NavigationOptions } from "swiper/types";
import { debounce } from "lodash-es";
import { HTMLAttributes } from "vue";
import { CatalogData } from "ecom-types";
import ProductListCarouselCard from "./ProductListCarouselCard.vue";
import { screens } from "@/configs/breakpointsConfig.json";
import { plpTypes } from "~/configs";

const props = defineProps<{
  title?: string;
  statisticItemListName?: string;
  statisticItemListId?: string;
  products: CatalogData[];
  class?: HTMLAttributes["class"];
}>();

const isMounted = useMounted();
const { viewItemListEvent } = useEvents();

const hideArrows = ref(true);

const prevEl = ref<HTMLElement | null>(null);
const nextEl = ref<HTMLElement | null>(null);

const debounceSwiper = debounce((params) => {
  hideArrows.value = params?.params?.slidesPerView >= props.products.length;
}, 200);

function initSwiper(params: any) {
  debounceSwiper(params);
}
function onUpdateSwiper(params: any) {
  debounceSwiper(params);
}

const navigation = reactive({
  prevEl,
  nextEl,
  disabledClass: "opacity-20 cursor-not-allowed",
}) as NavigationOptions;

const modules = [Navigation];

watchEffect(() => {
  if (isMounted.value && props.products) {
    const items = props.products.map((product: any) => {
      const { itemVariant } = useActiveMaterials(product);
      return { item_variant: itemVariant.value };
    });
    viewItemListEvent(props.products, {
      item_list_name: props.statisticItemListName,
      item_list_id: props.statisticItemListId,
      items,
    });
  }
});
</script>
